import { theme } from 'src/../tailwind.config'
import { IS_MOBILE_FIRST, isBrowser } from "./layout"
import React, { createContext, ReactNode, useContext, useEffect, useState } from "react"

export interface IScreenSizeContextProps {
  children?: ReactNode
}

const largeBreakpoint = parseInt(theme.extend.screens.lg, 10)
const mdBreakpoint = parseInt(theme.extend.screens.md, 10)

const getCurrentScreenSize = (): number => {
  if (isBrowser) {
    return window.innerWidth
  }
  return IS_MOBILE_FIRST ? mdBreakpoint - 1 : largeBreakpoint
}

const Context = createContext(getCurrentScreenSize())

export const ScreenSizeContextProvider = ({ 
  children,
}: IScreenSizeContextProps) => {
  const [screenSize, setScreenSize] = useState(getCurrentScreenSize)

  useEffect(() => {
    if (isBrowser) {
      const updateScreenSize = () => {
        setScreenSize(getCurrentScreenSize)
      }
      window.addEventListener('resize', updateScreenSize)
      
      const currentScreenSize = getCurrentScreenSize()
      if (currentScreenSize !== screenSize) {
        setScreenSize(currentScreenSize) // to be sure we did not skip any resize before listening started
      }
      
      return () => {
        window.removeEventListener('resize', updateScreenSize)
      }
    }
  }, [])

  return <Context.Provider value={screenSize}>
    {children}
  </Context.Provider> 
}

export const isLargeScreen = () =>
  getCurrentScreenSize() >= largeBreakpoint

export const useIsLargeScreen = () =>
  useContext(Context) >= largeBreakpoint

export const useIsMdScreen = () => 
  useContext(Context) >= mdBreakpoint

export const useIsMobile = () =>
  useContext(Context) < mdBreakpoint

export default ScreenSizeContextProvider
